export const tooltipMessages = {
  numberOfIncomesNeeded:
    'Please note some lenders wont accept all 4 incomes, in this case we will use the maximum number of incomes ' +
    'they will accept.',
  ltiText: 'LTI calculation only',
};
